import { render, staticRenderFns } from "./CampaignTagEdit.vue?vue&type=template&id=3c41a052"
import script from "./CampaignTagEdit.vue?vue&type=script&lang=ts"
export * from "./CampaignTagEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports